import axios from 'axios';

export default class ValidationService {
  constructor(csrfToken) {
    this.csrfToken = csrfToken;
  }

  validate = async (googlePlacesId) => {
    const formData = new FormData();
    formData.append('google_places_id', googlePlacesId);
    formData.append('csrfmiddlewaretoken', this.csrfToken);

    // validate that the selected google place id is unique in our system
    return axios.post('/signup/validate', formData);
  };
}
